<script>
/**
 * @overview 全局卡片组件
 *
 * @author huojinzhao
 */

export default {
  name: "AppCard",

  props: {
    width: {
      type: String,
      default: "200px",
    },

    height: {
      type: String,
      default: "200px",
    },

    radius: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classes() {
      return [
        this.radius ? "app-card--radius" : "",
        this.$slots.mask ? "" : "app-card--unmask",
      ];
    },

    style() {
      return { width: this.width, height: this.height };
    },
  },

  methods: {
    preventDisturb(e) {
      const isDisturb = e.srcElement === this.$refs.appCardMask;

      isDisturb && e.preventDefault();
    },
  },
};
</script>

<template>
  <figure
    :class="classes"
    :style="style"
    class="layout-mask-master app-card"
  >
    <slot />

    <figcaption
      v-if="$slots.mask"
      ref="appCardMask"
      class="layout-mask-attendant app-card__mask"
      @click="preventDisturb"
    >
      <div class="box">
        <slot name="mask" />
      </div>
    </figcaption>
  </figure>
</template>

<style lang="postcss">
.app-card {
  display: inline-block;
  margin: 0;
  position: relative;
  overflow: hidden;
  border: 1px solid var(--bd-color-default);
}

.app-card:hover {
  border: 1px solid var(--color-mask);
}

.app-card--radius {
  border-radius: var(--bd-radius);
}

figure.app-card--unmask:hover {
  border: 1px solid transparent;
  box-shadow: 0 0 10px 2px var(--bd-color-default);
}

.app-card--unmask:hover::before {
  display: none !important;
}
.layout-mask-master:hover .layout-mask-attendant{
  flex-wrap: wrap;
  margin-top: 0;
  /*top: -56px;*/
  /*height: 88px;*/

  display: flex;
  justify-content: center;
  align-items: center;
}
.layout-mask-master .box{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 100%;
}
</style>
